import React from 'react';
import { Clock } from 'lucide-react';

const BACKEND_URL = window.__BACKEND_URL__;
const API = `${BACKEND_URL}/api`;
const DEFAULT_LOGO = process.env.REACT_APP_LOGO_URL || "https://customer-assets.emergentagent.com/job_custom-timetrack/artifacts/sc80sbua_Hines%20Time.png";

const CompanyLogo = ({ company, className = "h-12" }) => {
  const logoUrl = company?.company_logo 
    ? `${API}/company/logo/${company.company_logo}`
    : DEFAULT_LOGO;

  return (
    <img 
      src={logoUrl}
      alt={company?.company_name || "Hines Time"}
      className={className}
      onError={(e) => {
        // Fallback to default logo if company logo fails to load
        e.target.src = DEFAULT_LOGO;
      }}
    />
  );
};

// Alternative text-based logo for small spaces
export const CompanyLogoSmall = ({ company }) => {
  const hasCustomLogo = company?.company_logo;

  if (hasCustomLogo) {
    return <CompanyLogo company={company} className="h-10 w-10 object-contain" />;
  }

  return (
    <div className="w-10 h-10 bg-gradient-to-br from-blue-600 to-green-600 rounded-lg flex items-center justify-center">
      <Clock className="w-6 h-6 text-white" />
    </div>
  );
};

export default CompanyLogo;
